import { Field, useFieldContext } from "@ark-ui/react/field";
import { cva } from "class-variance-authority";
import clsx from "clsx";
import type { ComponentProps } from "react";

type TextareaProps = ComponentProps<typeof Field.Textarea>;
type Props = TextareaProps & {};

const textareaVariants = cva(
  "transition-colors focus-visible:outline-none disabled:pointer-events-none placeholder:text-gray-500 text-gray-1000 rounded-4 p-2 text-sm border border-gray-500",
  {
    variants: {
      state: {
        default: "hover:border-gray-600 focus:border-gray-1000",
        readOnly: "bg-gray-10",
        disabled: "text-gray-300 bg-gray-100 placeholder:text-gray-300 border-gray-300",
        error: "border border-red-500 bg-red-10",
      },
    },
    defaultVariants: {
      state: "default",
    },
  },
);

const Textarea = ({ className, ...rest }: Props) => {
  const { disabled, readOnly, invalid } = useFieldContext();
  const state = disabled ? "disabled" : readOnly ? "readOnly" : invalid ? "error" : "default";

  return (
    <Field.Textarea
      {...rest}
      disabled={state === "disabled"}
      readOnly={state === "readOnly"}
      className={clsx(className, textareaVariants({ state }))}
    />
  );
};

export default Textarea;
